import { useState } from 'react';
import { XCircle, RotateCcw } from 'lucide-react';

export default function RejectedAccessPage() {
  const [reapplying, setReapplying] = useState(false);

  const handleReapply = () => {
    setReapplying(true);
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
    window.location.href = `${backendUrl}/api/auth/google/login`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-6">
          <XCircle size={32} className="text-red-500" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-7 h-7 rounded-lg bg-blue-600 flex items-center justify-center shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
          </div>
          <span className="text-slate-900 font-bold text-lg tracking-tight">Okebourne</span>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-3">Access Not Approved</h1>
        <p className="text-slate-500 text-sm leading-relaxed mb-6">
          Your access request was not approved. If you think this is a mistake,
          you can reapply and an admin will review your request again.
        </p>

        <button
          onClick={handleReapply}
          disabled={reapplying}
          className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-medium text-sm py-3 px-6 rounded-xl transition-colors mb-4"
        >
          <RotateCcw size={16} className={reapplying ? 'animate-spin' : ''} />
          {reapplying ? 'Redirecting...' : 'Reapply for Access'}
        </button>

        <p className="text-slate-400 text-xs">
          If you continue to have issues, contact your administrator directly.
        </p>

        <button
          onClick={() => window.location.href = '/login'}
          className="mt-4 text-xs text-slate-400 hover:text-slate-600 transition-colors underline underline-offset-2"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}